
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 6 3"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#007A3D","d":"M0 0h6v3H0z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M0 0h6v2H0z"}}),_c('path',{attrs:{"d":"M0 0h6v1H0z"}}),_c('path',{attrs:{"fill":"#CE1126","d":"M0 0l2 1.5L0 3z"}})])
          )
        }
      }
    